export default __webpack_public_path__ + "static/media/recent_chats.c3913c12.svg";